import React, { useRef } from 'react';
import styled from 'styled-components';
import Footer from './Footer';
import { CTGCBanner } from '../common/CTGCBanner';

type Props = React.HTMLAttributes<HTMLDivElement> & {
    footerPath?: string;
};

export const LandingLayout: React.FunctionComponent<Props> = ({ children, footerPath }) =>
{
    const ref = useRef<HTMLDivElement>(null);

    return (
        <Container id="container" ref={ref}>
            {children}
            <Footer path={footerPath} />
            <CTGCBanner />
        </Container>
    );
};

const Container = styled.div`
    position: relative;
    z-index: 0;
    width: 100%;
    height: 100vh;
    overflow-x: hidden;
    overflow-y: scroll;
    background: #fff;
`;

